<div 
    class="modal fade" 
    id="add-qr-code-modal" 
    tabindex="-1" 
    role="dialog"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h4 class="mb-0">
                    QR Code: {{ qrCodeName }}{{ registerFormEntryNumber > 0 ? ' #' + registerFormEntryNumber : '' }}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    (click)="close()">
                </button>
            </div>
            <div class="modal-body">
                <div class="p-text-center img-render">
                    <img src="{{qrCodeImage}}"
                            target="_blank"
                            title="QR Code" />
                </div>
                <div class="clearfix"></div>
                <div class="p-text-center">
                    <input 
                        type="button"
                        class="btn btn-secondary col-md-4"
                        value="Copy" 
                        (click)="copy()" 
                        [disabled]="!canCopy" hidden="hidden"
                    />
                    <input 
                        type="button"
                        class="btn btn-success col-md-4"
                        value="Download" 
                        (click)="download()"
                        [disabled]="!canDownload"
                    />
                    <input
                        #closeQRCodeModal
                        type="button" 
                        data-bs-dismiss="modal" 
                        class="btn btn-secondary col-md-4"
                        (click)="close()"
                        value="Close"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
